<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2e"><a id="page_15"></a><a id="frontmatter4"></a>The Destinations</h2>
<p class="image"><img alt="Image" src="images/pub.jpg"/></p>
<p class="image"><a id="page_16"></a><img alt="Image" src="images/f0016-01.jpg"/></p>
<p class="caption"><em>Most anglers reach the Karluk via floatplane, and more often than not, the craft of choice is the de Havilland DHC-2 Beaver.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter4.vue?7279a951